exports.install = function(Vue, options){
    Vue.prototype.to_html=(input)=>{
      return (input|| '').replaceAll(" ","&nbsp;").replaceAll("\n","<br />")
    }
    Vue.prototype.moment= require('moment')
}